<form [formGroup]="iForm" name="iForm" (ngSubmit)="submit()" class="field-sm">
    <div class="row">
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Date Of Birth</mat-label>
                <input matInput placeholder="DD/MM/YYYY" [matDatepicker]="picker" (click)="picker.open()" formControlName="birthDate" name="birthDate" required autocomplete="off">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="f.birthDate.errors?.required && f.birthDate.touched">
                    Date Of Birth is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Given Name</mat-label>
                <input matInput placeholder="Given Name" formControlName="givenName" autocomplete="off" required>
                <mat-error *ngIf="f.givenName.errors?.required && f.givenName.touched">
                    Given Name is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Middle Name</mat-label>
                <input matInput placeholder="Middle Name" formControlName="middleName" autocomplete="off">
            </mat-form-field>
        </div>
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Family Name</mat-label>
                <input matInput placeholder="Family Name" formControlName="familyName" autocomplete="off" required>
                <mat-error *ngIf="f.familyName.errors?.required && f.familyName.touched">
                    Family Name is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>

        

        <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Suburb</mat-label>
                <input matInput placeholder="Suburb" formControlName="suburb" autocomplete="off" required>
                <mat-error *ngIf="f.suburb.errors?.required && f.suburb.touched">
                    Suburb is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>
     
        <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>State</mat-label>
                <mat-select formControlName="state" autocomplete="off" required>
                    <mat-option *ngFor="let item of stateList" [value]="item.name">
                        <span class="bold">{{item.name}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Postcode</mat-label>
                <input matInput placeholder="Postcode" formControlName="postcode" autocomplete="off" required>
                <mat-error *ngIf="f.postcode.errors?.required && f.postcode.touched">
                    Postcode is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Street Name</mat-label>
                <input matInput placeholder="Street Name" formControlName="streetName" autocomplete="off">
            </mat-form-field>
        </div>

        <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Street Type</mat-label>
                <input matInput placeholder="Street Type" formControlName="streetType" autocomplete="off">
            </mat-form-field>
        </div>

        <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Street Number</mat-label>
                <input matInput placeholder="Street Number" formControlName="streetNumber" autocomplete="off">
            </mat-form-field>
        </div>

        <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Flat/Unit Number</mat-label>
                <input matInput placeholder="Flat/Unit Number" formControlName="flatUnitNumber" autocomplete="off">
            </mat-form-field>
        </div>

        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100 bold">
                <mat-label>Building Name</mat-label>
                <input matInput placeholder="Building Name" formControlName="habitationBuildingName" autocomplete="off">
            </mat-form-field>
        </div>

       

        <div class="col-md-12 text-center">
            <button class="btn btn-success btn-sm bold" type="submit" [disabled]="iForm.invalid">
                Verify
            </button>
        </div>

    </div>
</form>